/** THIS FILE IS AUTOMATICALLY GENERATED FROM : https://astral-api-webapp-test.azurewebsites.net//swagger/v1/swagger.json **/

import axios from "../axios"
import * as Astral from "./HachsharaInterfaces"

export const getAccountGenerateVerificationOtpCode = (
  mobilePhone: string,
  locale?: string
) =>
  axios.get<Astral.GenerateOtpResponseResponseWrapper>(
    `/api/account/generateVerificationOtpCode`,
    { params: { mobilePhone }, headers: { "X-Accept-Language": locale } }
  )

export const postAccountVerifyUserOtp = (
  data: Astral.VerificationOtpRequest,
  locale?: string
) =>
  axios.post<Astral.VerificationOtpResponseResponseWrapper>(
    `/api/account/verifyUserOtp`,
    data,
    { headers: { "X-Accept-Language": locale } }
  )

export const getAccountGenerateVerificationCode = (
  mobilePhone: string,
  toSendSms: boolean = true,
  locale?: string
) =>
  axios.get<Astral.GenerateVerificationCodeResponseResponseWrapper>(
    `/api/account/generateVerificationCode`,
    {
      params: { mobilePhone, toSendSms },
      headers: { "X-Accept-Language": locale },
    }
  )

export const getAccountGetGuestById = (
  id: number /* double */,
  locale?: string
) =>
  axios.get<Astral.GuestModelResponseWrapper>(`/api/account/GetGuestById`, {
    params: { id },
    headers: { "X-Accept-Language": locale },
  })

export const getAccountGetGuestByPhoneNumber = (
  phone: string,
  locale?: string
) =>
  axios.get<Astral.GuestModelResponseWrapper>(
    `/api/account/GetGuestByPhoneNumber`,
    { params: { phone }, headers: { "X-Accept-Language": locale } }
  )

export const postAccountVerifyUser = (
  data: Astral.VerifyUserRequest,
  locale?: string
) =>
  axios.post<Astral.VerifyUserResponseResponseWrapper>(
    `/api/account/verifyUser`,
    data,
    { headers: { "X-Accept-Language": locale } }
  )

export const postAccountRegisterGuest = (
  data: Astral.GuestInsertRequest,
  locale?: string
) =>
  axios.post<Astral.RegistrationResponseResponseWrapper>(
    `/api/account/RegisterGuest`,
    data,
    { headers: { "X-Accept-Language": locale } }
  )

export const postAccountUpdateGuestInfo = (
  data: Astral.GuestUpdateInfoRequest,
  locale?: string
) =>
  axios.post<Astral.UpdateMembeInfoResponseResponseWrapper>(
    `/api/account/UpdateGuestInfo`,
    data,
    { headers: { "X-Accept-Language": locale } }
  )

export const getCacheCleanCache = (locale?: string) =>
  axios.get<Astral.BooleanResponseWrapper>(`/api/cache/CleanCache`, {
    headers: { "X-Accept-Language": locale },
  })

export const postContactUsSendCv = (
  data: Astral.JobCvRequest,
  locale?: string
) =>
  axios.post<Astral.EmailResponseResponseWrapper>(
    `/api/contactUs/SendCv`,
    data,
    { headers: { "X-Accept-Language": locale } }
  )

export const postContactUsSendLead = (
  data: Astral.LeadRequest,
  locale?: string
) =>
  axios.post<Astral.EmailResponseResponseWrapper>(
    `/api/contactUs/SendLead`,
    data,
    { headers: { "X-Accept-Language": locale } }
  )

export const postContactUsSendGroupLead = (
  data: Astral.GroupBookingRequest,
  locale?: string
) =>
  axios.post<Astral.EmailResponseResponseWrapper>(
    `/api/contactUs/SendGroupLead`,
    data,
    { headers: { "X-Accept-Language": locale } }
  )

export const getCouponValidateCoupon = (code: string, locale?: string) =>
  axios.get<Astral.CouponValidationResponseResponseWrapper>(
    `/api/coupon/ValidateCoupon`,
    { params: { code }, headers: { "X-Accept-Language": locale } }
  )

export const postCouponSyncCouponsFromUmbraco = (locale?: string) =>
  axios.post<Astral.Int32ResponseWrapper>(
    `/api/coupon/SyncCouponsFromUmbraco`,
    { headers: { "X-Accept-Language": locale } }
  )

export const getSettingsAll = (locale?: string) =>
  axios.get<Astral.GeneralSettingResponseListResponseWrapper>(
    `/api/settings/all`,
    { headers: { "X-Accept-Language": locale } }
  )

export const getHotelGetAllHotels = (locale?: string) =>
  axios.get<Astral.HotelsResponseListResponseWrapper>(
    `/api/hotel/GetAllHotels`,
    { headers: { "X-Accept-Language": locale } }
  )

export const getHotelGetHotel = (
  hotelId: number /* int32 */,
  locale?: string
) =>
  axios.get<Astral.HotelsResponseResponseWrapper>(`/api/hotel/GetHotel`, {
    params: { hotelId },
    headers: { "X-Accept-Language": locale },
  })

export const getHotelGetRooms = (
  hotelId: number /* int32 */,
  language: Astral.Languages,
  locale?: string
) =>
  axios.get<Astral.RoomTranslationListResponseWrapper>(`/api/hotel/GetRooms`, {
    params: { hotelId, language },
    headers: { "X-Accept-Language": locale },
  })

export const postMembersGetMember = (
  data: Astral.GuestRequest,
  locale?: string
) =>
  axios.post<Astral.ProfileModelResponseWrapper>(
    `/api/members/GetMember`,
    data,
    { headers: { "X-Accept-Language": locale } }
  )

export const getMembersGetMemberById = (
  id: number /* double */,
  locale?: string
) =>
  axios.get<Astral.ProfileModelResponseWrapper>(`/api/members/GetMemberById`, {
    params: { id },
    headers: { "X-Accept-Language": locale },
  })

export const getMembersGetMemberByPhoneNumber = (
  phone: string,
  locale?: string
) =>
  axios.get<Astral.ProfileModelResponseWrapper>(
    `/api/members/GetMemberByPhoneNumber`,
    { params: { phone }, headers: { "X-Accept-Language": locale } }
  )

export const getMembersGetClubMemberByEmailAndPassword = (
  email: string,
  password: string,
  locale?: string
) =>
  axios.get<Astral.ClubMemberModelResponseWrapper>(
    `/api/members/GetClubMemberByEmailAndPassword`,
    { params: { email, password }, headers: { "X-Accept-Language": locale } }
  )

export const postMembersRegisterGuest = (
  data: Astral.GuestInsertRequest,
  locale?: string
) =>
  axios.post<Astral.InsertGuestResponseResponseWrapper>(
    `/api/members/RegisterGuest`,
    data,
    { headers: { "X-Accept-Language": locale } }
  )

export const postMembersUpdateGuestInfo = (
  data: Astral.GuestUpdateInfoRequest,
  locale?: string
) =>
  axios.post<Astral.UpdateMembeInfoResponseResponseWrapper>(
    `/api/members/UpdateGuestInfo`,
    data,
    { headers: { "X-Accept-Language": locale } }
  )

export const postMembersUpdateGestToClubMember = (
  data: Astral.UpdateGuestToClubMemberRequest,
  locale?: string
) =>
  axios.post<Astral.CreateTransactionResponseResponseWrapper>(
    `/api/members/UpdateGestToClubMember`,
    data,
    { headers: { "X-Accept-Language": locale } }
  )

export const postMembersRegisterClubMember = (
  data: Astral.ClubMemberInsertRequest,
  locale?: string
) =>
  axios.post<Astral.CreateTransactionResponseResponseWrapper>(
    `/api/members/RegisterClubMember`,
    data,
    { headers: { "X-Accept-Language": locale } }
  )

export const postMembersActivateClubMember = (
  data: Astral.ActivateClubMemberAfterPaymentRequest,
  locale?: string
) =>
  axios.post<Astral.ActivateClubResponseResponseWrapper>(
    `/api/members/ActivateClubMember`,
    data,
    { headers: { "X-Accept-Language": locale } }
  )

export const postMembersUpdateClubMemberInfo = (
  data: Astral.ClubMemberUpdateInfoRequest,
  locale?: string
) =>
  axios.post<Astral.UpdateMembeInfoResponseResponseWrapper>(
    `/api/members/UpdateClubMemberInfo`,
    data,
    { headers: { "X-Accept-Language": locale } }
  )

export const postNotificationAbandonedCart = (
  data: Astral.AbandonedCartTrigger,
  locale?: string
) =>
  axios.post<Astral.BooleanResponseWrapper>(
    `/api/notification/abandoned-cart`,
    data,
    { headers: { "X-Accept-Language": locale } }
  )

export const postNotificationInvoice = (
  data: Astral.NewInvoiceTrigger,
  locale?: string
) =>
  axios.post<Astral.BooleanResponseWrapper>(`/api/notification/invoice`, data, {
    headers: { "X-Accept-Language": locale },
  })

export const getPaymentCompletePayment = (
  success: boolean,
  type: string,
  uniqueId: string,
  PelecardTransactionId: string,
  PelecardStatusCode: string,
  ApprovalNo: string,
  Token: string,
  ConfirmationKey: string,
  ParamX: string,
  UserKey: string,
  locale?: string
) =>
  axios.get<Astral.CompletePaymentResponse>(`/api/payment/completePayment`, {
    params: {
      success,
      type,
      uniqueId,
      PelecardTransactionId,
      PelecardStatusCode,
      ApprovalNo,
      Token,
      ConfirmationKey,
      ParamX,
      UserKey,
    },
    headers: { "X-Accept-Language": locale },
  })

export const getPriceCelanderGetCelanderPrices = (locale?: string) =>
  axios.get<Astral.PricingResponseResponseWrapper>(
    `/api/priceCelander/GetCelanderPrices`,
    { headers: { "X-Accept-Language": locale } }
  )

export const getPriceCelanderGetHotelCelanderPrices = (
  hotelId: number /* int32 */,
  locale?: string
) =>
  axios.get<Astral.PricingCalendarHotelResponseResponseWrapper>(
    `/api/priceCelander/GetHotelCelanderPrices`,
    { params: { hotelId }, headers: { "X-Accept-Language": locale } }
  )

export const getPromotionsUpsalesGetAllPromotions = (locale?: string) =>
  axios.get<Astral.HotelPromotionsListResponseWrapper>(
    `/api/promotionsUpsales/GetAllPromotions`,
    { headers: { "X-Accept-Language": locale } }
  )

export const getPromotionsUpsalesGetPromotionsByHotel = (
  hotelId: number /* int32 */,
  locale?: string
) =>
  axios.get<Astral.PromotionModelListResponseWrapper>(
    `/api/promotionsUpsales/GetPromotionsByHotel`,
    { params: { hotelId }, headers: { "X-Accept-Language": locale } }
  )

export const getPromotionsUpsalesGetPromotionsByOrder = (
  order: number /* int32 */,
  locale?: string
) =>
  axios.get<Astral.PromotionModelListResponseWrapper>(
    `/api/promotionsUpsales/GetPromotionsByOrder`,
    { params: { order }, headers: { "X-Accept-Language": locale } }
  )

export const postPromotionsUpsalesGetSpecialService = (
  data: Astral.SpecialServiceRequest,
  locale?: string
) =>
  axios.post<Astral.SpecialServiceModelListResponseWrapper>(
    `/api/promotionsUpsales/GetSpecialService`,
    data,
    { headers: { "X-Accept-Language": locale } }
  )

export const postReservationGetRoomDetails = (
  hotelId: number /* int32 */,
  data: string[],
  locale?: string
) =>
  axios.post<Astral.ReservationDetailsResponseWrapper>(
    `/api/reservation/GetRoomDetails`,
    data,
    { params: { hotelId }, headers: { "X-Accept-Language": locale } }
  )

export const postReservationStartTransaction = (
  data: Astral.StartTransactionRequest,
  locale?: string
) =>
  axios.post<Astral.CreateTransactionResponseResponseWrapper>(
    `/api/reservation/StartTransaction`,
    data,
    { headers: { "X-Accept-Language": locale } }
  )

export const postReservationCreateReservation = (
  data: Astral.ReservationRequest,
  locale?: string
) =>
  axios.post<Astral.ReservationResponseResponseWrapper>(
    `/api/reservation/CreateReservation`,
    data,
    { headers: { "X-Accept-Language": locale } }
  )

export const postReservationCancelReservation = (
  data: Astral.CancelReservationRequest,
  locale?: string
) =>
  axios.post<Astral.CancelReservationResponseResponseWrapper>(
    `/api/reservation/CancelReservation`,
    data,
    { headers: { "X-Accept-Language": locale } }
  )

export const postSearchSearchRooms = (
  data: Astral.SearchRequest,
  locale?: string
) =>
  axios.post<Astral.SearchResponseResponseWrapper>(
    `/api/search/SearchRooms`,
    data,
    { headers: { "X-Accept-Language": locale } }
  )

export const getStaticAllHotels = (locale?: string) =>
  axios.get<Astral.HotelsResponseListResponseWrapper>(`/api/static/AllHotels`, {
    headers: { "X-Accept-Language": locale },
  })

export const getStaticHotel = (hotelId: number /* int32 */, locale?: string) =>
  axios.get<Astral.HotelsResponseResponseWrapper>(`/api/static/Hotel`, {
    params: { hotelId },
    headers: { "X-Accept-Language": locale },
  })

export const getStaticAllRoomInfo = (
  languageId: Astral.Languages,
  locale?: string
) =>
  axios.get<Astral.RoomTranslationListResponseWrapper>(
    `/api/static/AllRoomInfo`,
    { params: { languageId }, headers: { "X-Accept-Language": locale } }
  )

export const getStaticRoomInfo = (
  languageId: Astral.Languages,
  hotelId: number /* int32 */,
  category: string,
  locale?: string
) =>
  axios.get<Astral.RoomTranslationResponseWrapper>(`/api/static/RoomInfo`, {
    params: { languageId, hotelId, category },
    headers: { "X-Accept-Language": locale },
  })

export const getStaticAllPricingCode = (
  languageId: number /* int32 */,
  locale?: string
) =>
  axios.get<Astral.PriceCodeTranslationListResponseWrapper>(
    `/api/static/AllPricingCode`,
    { params: { languageId }, headers: { "X-Accept-Language": locale } }
  )

export const getStaticPricingCode = (
  languageId: Astral.Languages,
  hotelId: number /* int32 */,
  priceCode: string,
  locale?: string
) =>
  axios.get<Astral.PriceCodeTranslationResponseWrapper>(
    `/api/static/PricingCode`,
    {
      params: { languageId, hotelId, priceCode },
      headers: { "X-Accept-Language": locale },
    }
  )

export const getStaticAllPlanCode = (
  languageId: number /* int32 */,
  locale?: string
) =>
  axios.get<Astral.PlanTranslationListResponseWrapper>(
    `/api/static/AllPlanCode`,
    { params: { languageId }, headers: { "X-Accept-Language": locale } }
  )

export const getStaticPlanCode = (
  languageId: Astral.Languages,
  hotelId: number /* int32 */,
  planCode: string,
  locale?: string
) =>
  axios.get<Astral.PlanTranslationResponseWrapper>(`/api/static/PlanCode`, {
    params: { languageId, hotelId, planCode },
    headers: { "X-Accept-Language": locale },
  })

export const getStaticAllCancellationPolicy = (
  hotelId: number /* int32 */,
  locale?: string
) =>
  axios.get<Astral.CancellationPolicyTranslationListResponseWrapper>(
    `/api/static/AllCancellationPolicy`,
    { params: { hotelId }, headers: { "X-Accept-Language": locale } }
  )

export const getStaticCancellationPolicy = (
  hotelId: number /* int32 */,
  cancellationPolicyCode: string,
  locale?: string
) =>
  axios.get<Astral.CancellationPolicyTranslationResponseWrapper>(
    `/api/static/CancellationPolicy`,
    {
      params: { hotelId, cancellationPolicyCode },
      headers: { "X-Accept-Language": locale },
    }
  )

export const getStaticGetClubInfo = (locale?: string) =>
  axios.get<Astral.ClubBaseInfoResponseResponseWrapper>(
    `/api/static/GetClubInfo`,
    { headers: { "X-Accept-Language": locale } }
  )
